import { render, staticRenderFns } from "./AudioPlayer.vue?vue&type=template&id=77b6bd4c"
import script from "./AudioPlayer.vue?vue&type=script&lang=ts"
export * from "./AudioPlayer.vue?vue&type=script&lang=ts"
import style0 from "./AudioPlayer.vue?vue&type=style&index=0&id=77b6bd4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports